import { Action } from '@ngrx/store';

export interface IRetryAction {
  retryAction: Action;
}

export const isRetryAction = (
  action: (Action & IRetryAction) | any
): action is IRetryAction => {
  return (action as IRetryAction)?.retryAction !== undefined;
};
